<template>
    <div class="mb-4">
<!--            <chosen-multiselect id="add-usergroups" v-model="selectedValues" :hierarchical="true">-->
<!--                <option v-for="optiondata in fullUsergroupList.data"-->
<!--                        :data-level="optiondata.level">-->
<!--                </option>-->
<!--            </chosen-multiselect>-->
        <div id="select-usergroups" class="d-flex">
            <v-autocomplete
                aria-label="usergroups"
                id="add-usergroups"
                v-model="selectedValues"
                :label="t_usergroups"
                :items="fullUsergroupList.data"
                multiple
                outlined
                dense
                clearable
                hide-details="auto">
                <template v-slot:append-outer>
                    <v-tooltip-wrapper
                        v-if="t_usergroups_description"
                        :max-width="380"
                        content-class="tooltip-glass tooltip-white elevation-8">
                        <template #activator="{ on, attrs }">
                            <v-icon style="cursor: pointer"
                                    v-bind="attrs"
                                    v-on="on">
                                fa-light fa-circle-question
                            </v-icon>
                        </template>
                        {{ t_usergroups_description }}
                    </v-tooltip-wrapper>
                </template>
            </v-autocomplete>
        </div>
        <div class="mt-2 mb-4" id="strict-checkbox">
            <Checkbox id="strict"
                      class="mr-2"
                      binary
                      :modelValue="strict_mode"
                      :label="t_strict_mode"
                      @click="strict_mode = !strict_mode"
            />
            {{ t_strict_mode }}
            <v-tooltip-wrapper activator="#strict-checkbox">
                <span>{{ t_strict_mode_description }}</span>
            </v-tooltip-wrapper>
        </div>
    </div>
</template>

<script>
    import toaster from "../../../common/toaster";
    import Checkbox from "../../../content/common/PrimeVue/Checkbox.vue"
    import Template from "../../elements/template.vue";
    import elementIcon from "../../elements/element-icon.vue";
    import VTooltipWrapper from "../../../common/v-tooltip-wrapper.vue";

    export default {
        props: ['currentUsergroups', 'allUsergroups', 'value'],
        components: { VTooltipWrapper, elementIcon, Template, Checkbox },
        data: function () {
            return {
                t_usergroups: Lang.langGet("Add usergroups to media"),
                t_usergroups_description: Lang.langGet("If you leave this empty, the element will be available for everyone."),
                t_load_failed: Lang.langGet("Failed to load usergroups from database."),
                t_strict_mode: Lang.langGet("Strict Mode"),
                t_strict_mode_description: Lang.langGet("In \"Strict Mode\" users must have ALL selected usergroups."),
                fullUsergroupList: {data: this.allUsergroups},
                selectedValues: this.currentUsergroups,
                strict_mode: this.value
            }
        },
        watch: {
            strict_mode: function (val, oldVal) {
                this.$emit('input', val);
            },
            selectedValues: function (val, oldVal) {
                this.$emit('currentUsergroupsUpdated', val);
            }
        },
        methods: {
            loadUsergroups: function () {
                if (this.fullUsergroupList.data.length > 0) {
                    return;
                }

                axios.post('/content/mediapool/loadusergroups', {
                    id: Laravel.activeProject
                }).then((response) => {
                    this.fullUsergroupList.data = response.data.data;
                    this.$emit('allUsergroupsUpdated', this.fullUsergroupList.data);
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_failed);
                });
            }
        },
        computed: {
            createLabel: function() {
                return `<span :data-balloon="t_usergroups_description"
                          data-balloon-pos="right"
                          data-balloon-length="large">
                        <i class="fa-light fa-circle-question cursor-pointer"></i>
                    </span>`;
            }
        },
        mounted() {
            this.loadUsergroups();
        }
    }
</script>

<style scoped>

</style>
